import { intl } from '../../../../../../../../../i18n'
import { TicketListSelect } from '../../../../TicketListSelect'
import { usePageConfigHandlers } from '../hooks/usePageConfigHandlers'
import {
  ConfigContainer,
  SectionContent,
  FormSection,
  FormLabel,
  PageTitleInput,
} from '../styles'
import { VersionReportVersionPageFormModel } from '../../../model/VersionReportVersionPageFormModel'

type ProgressReportByTicketListConfigFormProps = {
  page: VersionReportVersionPageFormModel
  snapshotUuid: string
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
}

/** チケット別進捗状況の設定。行にするチケット管理表を選ぶ（選んだ順に行が並ぶ） */
export const ProgressReportByTicketListConfigForm = ({
  page,
  snapshotUuid,
  onUpdate,
}: ProgressReportByTicketListConfigFormProps) => {
  const { handlePageTitleChange, handleTableRowsChange } =
    usePageConfigHandlers(page, onUpdate)

  return (
    <ConfigContainer>
      <SectionContent>
        <FormSection>
          <PageTitleInput
            label={intl.formatMessage({
              id: 'versionReport.pageConfig.pageTitle',
            })}
            value={page.pageTitle}
            onChange={handlePageTitleChange}
            placeholder={intl.formatMessage({
              id: 'versionReport.pageConfig.pageTitle.placeholder',
            })}
            variant="outlined"
            required={true}
          />
        </FormSection>

        <FormSection>
          <FormLabel>
            {intl.formatMessage({
              id: 'versionReport.pageConfig.ticketLists',
            })}
          </FormLabel>
          <TicketListSelect
            key={page.pageNumber}
            snapshotUuid={snapshotUuid}
            value={page.config.tableRows}
            onChange={handleTableRowsChange}
            isMultiSelect={true}
          />
        </FormSection>
      </SectionContent>
    </ConfigContainer>
  )
}
